module.exports = __webpack_public_path__ + "img/credible-layer3.a1493cff.svg";